/**
 * @prettier
 */
export function envCOMMIT_AUTHOR_EMAIL(): string | undefined {
    return process.env.REACT_APP_COMMIT_AUTHOR_EMAIL;
}
